<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.careId"
		size="80%"
		title="寄养详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:10px;">
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<el-button type="danger" @click="stop(msg)" size="mini">结束所有宠物寄养</el-button>
					</el-col>
				</el-row> -->
				<el-row class="row">
					<el-col :span="12">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">手机号：</span>
						<span class="value">{{msg.memberMobile}}</span>
					</el-col>
					
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">支付类型：</span>
						<span class="value">{{msg.depositType===1?'押金':'余额'}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">押金(余额)：</span>
						<span class="value">{{msg.deposit}} 元</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">总寄养费：</span>
						<span class="value">{{allMoney}} 元</span>
					</el-col>
					<el-col :span="12">
						<span class="label">是否欠费：</span>
						<span class="value">
							{{$public.jian(msg.deposit,allMoney)?'未欠费':'已欠费'}}
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">创建人：</span>
						<span class="value">
							{{msg.createUserName}}
						</span>
					</el-col>
					<el-col :span="12">
						<span class="label">备注：</span>
						<span class="value">{{msg.remark}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label"></span>
						<span class="value"></span>
					</el-col>
					<el-col :span="12">
						<span class="label"></span>
						<span class="value">
							<el-button v-if="msg.canDelete===true" type="danger" @click="cancel(msg)" size="mini">取消所有宠物寄养</el-button>
						</span>
					</el-col>
				</el-row>
			</div>
			<div style="border-top:1px solid #aaa;padding:10px 0;" v-for="(item,index) in msg.pets" :key="index">
				<el-row class="row">
					<el-col :span="6">
						<span class="label">第 {{index+1}} 只宠物：</span>
						<span class="value">{{item.petName}}</span>
					</el-col>
					
					<el-col :span="6">
						<span class="label">状态：</span>
						<span class="value">
							<span v-if="item.status===1" style="color:red;margin-right: 6px;">寄养中</span>
							<span v-else>已寄养结束</span>
							<el-button v-if="item.status===1" type="success" @click="stopPet(item)" size="mini">取消当前宠物寄养</el-button>
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">种类：</span>
						<span class="value">{{item.className}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">品种：</span>
						<span class="value">{{item.typeName}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					
					<el-col :span="6">
						<span class="label">性别：</span>
						<span class="value">{{item.sex}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">体重：</span>
						<span class="value">{{item.weight}} kg</span>
					</el-col>
					<el-col :span="6">
						<span class="label">开始时间：</span>
						<span class="value">{{$public.FTime(item.beginDate,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">结束时间：</span>
						<span class="value">{{$public.FTime(item.endDate,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="6">
						<span class="label">活动：</span>
						<span class="value">{{item.activityName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">已产生寄养费：</span>
						<span class="value">{{item.totalMoney}} 元</span>
					</el-col>
					<!-- <el-col :span="6" v-if="item.cageInfo.positionName">
						<span class="label">笼子：</span>
						<span class="value">
							<span style="font-size: 15px;font-weight: 700;">{{item.cageInfo.positionName}}{{item.cageInfo.cageName}}</span>
						</span>
					</el-col> -->
					<el-col :span="6">
						<span class="label">备注：</span>
						<span class="value">{{item.remark}}</span>
					</el-col>
				</el-row>
				<div style="padding:20px 0px 0;float: none;font-size: 14px;">
					<el-table :data="item.goodsList" height="300px" style="width: 100%">
						<el-table-column label="单号" width="175">
							<template slot-scope="scope">
								<span>{{scope.row.orderNum}}</span>
							</template>
						</el-table-column>
						<el-table-column label="名称" width="150">
							<template slot-scope="scope">
								{{scope.row.goodsName}}
							</template>
						</el-table-column>
						<el-table-column label="规格">
							<template slot-scope="scope">
								{{scope.row.skuValue}}
							</template>
						</el-table-column>
						<el-table-column label="单价" width="70">
							<template slot-scope="scope">
								{{scope.row.price}}
							</template>
						</el-table-column>
						<el-table-column label="数量" width="135">
							<template slot-scope="scope">
								{{scope.row.num}}
							</template>
						</el-table-column>
						<el-table-column label="单位" width="140">
							<template slot-scope="scope">
								{{scope.row.unit}}
							</template>
						</el-table-column>
						<el-table-column label="总价" width="135">
							<template slot-scope="scope">
								{{scope.row.totalMoney}}
							</template>
						</el-table-column>
						<el-table-column label="时间" width="170">
							<template slot-scope="scope">
								{{$public.FTime(scope.row.fosterCareDate,'YYYY-MM-DD')}}
							</template>
						</el-table-column>
						<!-- <el-table-column label="销售人员" width="200">
							<template slot-scope="scope" v-if="item.status===1">
								<el-select v-model="scope.row.salesMans" multiple filterable placeholder="请选择" size="mini" style="width:180px;margin-bottom:20px;">
									<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
									:value="item._id+','+item.basic_info.nick_name"></el-option>
								</el-select>
							</template>
						</el-table-column> -->
					</el-table>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				allMoney:0,
				staffList:[]
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.getStaffList();
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getGoodsMsg(this.curItem.careId)
			})
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			// 获取商品信息
			getGoodsMsg(careId) {
				let loading = this.$loading()
				this.$http.get('/api/FosterCare/Detail', {
					careId: careId
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.msg = res.data;
						this.allMoney = 0;
						for(let i=0;i<this.msg.pets.length;i++){
							let item = this.msg.pets[i];
							this.allMoney = this.$public.jia(this.allMoney,item.totalMoney)
							for(let a=0;a<item.goodsList.length;a++){
								this.$set(item.goodsList[a],'salesMans',[])
							}
						}
					}
				})
			},
			cancel(row){
				this.$confirm('确定要取消所有宠物寄养?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"careId": row.careId,
					}
					let loading = this.$loading()
					this.$http.delete('/api/FosterCare/Delete', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('close')
						}
					})
				})
			},
			stopPet(row){
				// let finishList = [];
				// for(let i=0;i<row.goodsList.length;i++){
				// 	let finishItem = {
				// 		goodsItemsId:row.goodsList[i].itemsId,
				// 		salesMans:[],
				// 	}
				// 	if(this.$public.isNull(row.goodsList[i].salesMans)){
				// 		this.$message({
				// 			message: '请输入销售人员！',
				// 			type: 'error'
				// 		});
				// 		return ;
				// 	}else{
				// 		for(let a=0;a<row.goodsList[i].salesMans.length;a++){
				// 			finishItem.salesMans.push({
				// 				"userId": row.goodsList[i].salesMans[a].split(',')[0],
				// 				"userName": row.goodsList[i].salesMans[a].split(',')[1],
				// 			})
				// 		}
				// 		finishList.push(finishItem)
				// 	}
				// }
				this.$confirm('确定要取消当前宠物寄养?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"petRecordId": row.recordId,
					}
					let loading = this.$loading()
					this.$http.delete('/api/FosterCare/DeleteCarePets', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('close')
						}
					})
				})
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;padding:0 0 50px;
			}
		}
		.row{
			padding:14px 20px 14px;float: none;font-size: 13px;color:#666;
			.label{
				display: inline-block;width:100px;text-align: right;
			}
		}
	}
	
</style>
